import {Injectable, QueryList} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {CloMobileCard} from './table';

interface Filter {
  value: any;
  title: string;
  attribute: string;
}

@Injectable({
  providedIn: 'root'
})
export class CloFilterTableService {

  private listOfAppliedFilters = {};
  private tablesSearchableData = {};
  private searchTerms = {};
  public tableTypeName;

  // private mobileCards: QueryList<CloMobileCard>;
  private possibleCardsSource = new BehaviorSubject({});
  observableMobileCards = this.possibleCardsSource.asObservable();

  private appliedFilterSource = new BehaviorSubject(this.listOfAppliedFilters);
  appliedFilters = this.appliedFilterSource.asObservable();

  private searchableStringsSource = new BehaviorSubject({});
  searchableData = this.searchableStringsSource.asObservable();

  private searchFieldTermSource = new BehaviorSubject({});
  searchFieldTerm = this.searchFieldTermSource.asObservable();

  private tableObjectsSource = new BehaviorSubject({});
  tableObjects = this.tableObjectsSource.asObservable();

  private mobileSearchSource = new BehaviorSubject({});
  mobileSearch = this.mobileSearchSource.asObservable();

  constructor() {

  }

  addMultipleFilters(tableId: string, filters: Filter[]) {
    if (!this.listOfAppliedFilters[tableId]) {
      this.listOfAppliedFilters[tableId] = [];
    }

    filters.forEach( newFilter => {
      const index = this.listOfAppliedFilters[tableId].indexOf( i => i.value === newFilter.value);
      if (index < 0) {
        this._addFilter(tableId, newFilter);
      } else {
        this._removeFilter(tableId, newFilter);
      }
    });

    this.appliedFilterSource.next(this.listOfAppliedFilters);
  }

  addFilter(tableId: string, newFilter: Filter) {
    if (!this.listOfAppliedFilters[tableId]) {
      this.listOfAppliedFilters[tableId] = [];
    }
    const index = this.listOfAppliedFilters[tableId].findIndex( i => {
      return i.value === newFilter.value;
    });
    // console.log('Index: ' + index);
    if (index < 0) {
      // console.log('Add filter');
      this._addFilter(tableId, newFilter);
    } else {
      // console.log('Remove filter');
      this._removeFilter(tableId, newFilter);
    }
    this.appliedFilterSource.next(this.listOfAppliedFilters);
  }

  removeFilter(tableId: string, oldFilter: Filter) {}

  getFiltersForTable(tableId: string) {
    return this.listOfAppliedFilters[tableId];
  }

  private _addFilter(tableId: string, newFilter: Filter) {
    this.listOfAppliedFilters[tableId].push(newFilter);
  }

  private _removeFilter(tableId: string, newFilter: Filter) {
    const index = this.listOfAppliedFilters[tableId].findIndex(i => {
      return i.value === newFilter.value;
    });
    this.listOfAppliedFilters[tableId].splice(index, 1);
  }

  clearFilters(tableId: string) {
    this.listOfAppliedFilters[tableId] = [];
    this.appliedFilterSource.next(this.listOfAppliedFilters);
  }

  setSearchableData(tableId: string, data: Array<any>) {
    this.tablesSearchableData[tableId] = data;
    this.searchableStringsSource.next(this.tablesSearchableData);
  }

  updateSearchTerm(searchTerm, tableId) {
    const term = searchTerm || '';
    this.searchTerms[tableId] = term;
    this.searchFieldTermSource.next(this.searchTerms);
  }

  clearSearch(tableId) {
    this.searchTerms[tableId] = undefined;
    this.searchFieldTermSource.next(this.searchTerms);
  }
  updateMobileCards(tableId, mobileCards: QueryList<CloMobileCard>) {
    let value = this.possibleCardsSource.value;
    value[tableId] = mobileCards;
    this.possibleCardsSource.next(value);

  }
}
